import { StandardEvents } from '@shopify/events';

document.addEventListener('click', async event => {
  const link = event.target instanceof Element ? event.target.closest('a.grand-utility--cart') : null;
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  await customElements.whenDefined('theme-drawer');
  document.querySelectorAll('.grand-mobile-menu[open]').forEach(menu => { menu.open = false; });
  drawer.open();
});

function updateCount(count) {
  if (!Number.isFinite(count) || count < 0) return;
  document.querySelectorAll('[data-grand-cart-count]').forEach(element => {
    element.textContent = String(count);
    const link = element.closest('a');
    if (link) link.setAttribute('aria-label', `${link.dataset.grandCartLabel || 'Cart'} (${count})`);
  });
}
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({ cart, detail }) => updateCount(cart?.totalQuantity ?? detail?.itemCount)).catch(() => {});
});
window.addEventListener('pageshow', event => {
  if (!event.persisted || !document.body.dataset.grandCartUrl) return;
  fetch(document.body.dataset.grandCartUrl, { headers: { Accept: 'application/json' } })
    .then(response => response.ok ? response.json() : null)
    .then(cart => { if (cart) updateCount(cart.item_count); })
    .catch(() => {});
});
